import { Divider, Grid, IconButton, Typography } from '@mui/material';
import { FacebookIcon, GoogleIcon, InstagramIcon, LinkedinIcon, TwitterIcon } from '../../assets/icons';
import { SocialLinks } from '../../types/siteSetting';
import { footerStyles } from './styles';
import _ from 'lodash';
import { AppIcon } from '../app-icon/AppIcon';

interface FooterSocialIconSectionProps {
  socialLinks: SocialLinks;
}

export const FooterSocialIconSection: React.FC<FooterSocialIconSectionProps> = ({ socialLinks }) => {
  const renderSocialLink = (Icon: typeof FacebookIcon, label: string, link?: string) => {
    if (!link) {
      return null;
    }
    return (
      <IconButton sx={footerStyles.socialIconButton} href={link} target="_blank" component="a" aria-label={label}>
        <AppIcon color="secondary" Icon={Icon} titleAccess={label} />
      </IconButton>
    );
  };

  return (
    <Grid container spacing={2.5} sx={footerStyles.socialSection}>
      <Grid item sx={footerStyles.socialIconContainer} xs="auto">
        {_.compact(_.values(socialLinks)).length > 0 && (
          <>
            <Typography variant="small" sx={footerStyles.socialIconLabel} color="secondary" component="span">
              Follow us on
            </Typography>
            <Divider orientation="vertical" flexItem sx={footerStyles.socialIconDivider} />
            {renderSocialLink(FacebookIcon, 'View our facebook profile', socialLinks.site_facebook_link)}
            {renderSocialLink(GoogleIcon, 'View our google profile', socialLinks.site_google_link)}
            {renderSocialLink(InstagramIcon, 'View our instagram profile', socialLinks.site_instagram_link)}
            {renderSocialLink(LinkedinIcon, 'View our linkedin profile', socialLinks.site_linkedin_link)}
            {renderSocialLink(TwitterIcon, 'View our twitter profile', socialLinks.site_twitter_link)}
          </>
        )}
      </Grid>
    </Grid>
  );
};
